<!-- #23 -->
<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        List of Address
      </div>
    </div>
    <v-divider class="mt-1 mb-4"></v-divider>
    <v-data-table
      :headers="headers"
      :items="addresses"
      :options.sync="options"
      :server-items-length="total"
      :loading="addressesLoader"
      class="elevation-1"
      :footer-props="{
        itemsPerPageOptions: [25, 50, 100, 250],
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus',
      }"
    >
      <template v-slot:top>
        <v-row class="mt-0">
          <v-col
            cols="12"
            md="6"
            class="d-flex flex-column align-left justify-center mt-2 pt-0"
          >
            <v-toolbar-title class="pl-4 text-h6">
              Client Address(es)
            </v-toolbar-title>
          </v-col>
          <v-col cols="12" md="6" class="d-flex justify-end">
            <v-btn
              color="primary"
              dark
              class="mb-2 text-end mr-4"
              small
              @click="addAddress()"
              v-if="checkPermission('app_client:client_address_create')"
              >Add New Address</v-btn
            >
            <v-select
              label="Client"
              :rules="[(v) => !!v || 'CLient is required.']"
              class="required pt-0 pr-4"
              v-model="selectedClient"
              :items="clients"
              hide-no-data
              hide-details
              item-text="name"
              item-value="id"
              dense
              outlined
              @change="clientTypeList()"
            ></v-select>
          </v-col>
        </v-row>
        <v-divider class="mt-3"></v-divider>

        <v-dialog
          v-model="dialog"
          max-width="650px"
          @keydown.esc="close"
          persistent
        >
          <v-card>
            <v-card-title>
              <span class="text-h5"
                >{{ formTitle }} Address
                <i class="caption red--text ml-4"> * required field</i></span
              >
            </v-card-title>
            <v-divider class="mt-3"></v-divider>

            <v-card-text class="pb-0">
              <v-container>
                <v-form ref="form">
                  <v-row class="pb-0">
                    <v-col cols="12" sm="6" md="6" class="pb-0">
                      <v-select
                        v-model="editedAddress.address_type"
                        label="Address Type"
                        :rules="[
                          (v) =>
                            (v !== '' && v !== null) || 'Type is required.',
                        ]"
                        class="required pb-0"
                        outlined
                        :items="addressTypes"
                      ></v-select>
                    </v-col>
                  </v-row>
                  <v-row class="pb-0">
                    <v-col cols="12" sm="12" md="12" class="pb-0">
                      <v-text-field
                        v-model="editedAddress.street_address"
                        label="Address Line1"
                        :rules="[
                          (v) =>
                            (v && !!v.trim()) || 'Address Line1 is required.',
                        ]"
                        outlined
                        class="required pb-0"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" class="pb-0">
                      <v-text-field
                        v-model="editedAddress.address_area"
                        label="Address Line2"
                        outlined
                        class="pb-0"
                      ></v-text-field>
                    </v-col>

                    <!-- <v-col cols="12" sm="6" md="6">
                      <v-text-field
                      
                        v-model="editedAddress.city_name"
                        label="City"
                        :rules="[
                          (v) => (v && !!v.trim()) || 'City name is required.',
                        ]"
                        class="required"
                      ></v-text-field>
                    </v-col>
                     -->
                    <v-col cols="12" sm="6" md="6" class="pb-0">
                      <v-autocomplete
                        label="Country"
                        :items="allCountries"
                        item-text="name"
                        item-value="code"
                        @input="cityList(editedAddress.country_code)"
                        v-model="editedAddress.country_code"
                        :rules="[(v) => !!v || 'Country is required']"
                        class="required pb-0"
                        outlined
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" class="pb-0">
                      <v-autocomplete
                        label="City"
                        :items="citiesList"
                        item-text="name"
                        item-value="name"
                        v-model="editedAddress.city_name"
                        :rules="[(v) => !!v || 'City is required']"
                        class="required pb-0"
                        :loading="cityLoader"
                        outlined
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" class="pb-0">
                      <v-text-field
                        v-model="editedAddress.zip_code"
                        label="Pincode / Zipcode"
                        outlined
                        class="pb-0"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" class="pb-0">
                      <v-text-field
                        v-model="editedAddress.phone_number"
                        label="Phone Number"
                        :rules="[
                          (v) =>
                            (v && !!v.trim()) || 'Phone number is required.',
                        ]"
                        class="required pb-0"
                        outlined
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" class="pb-0">
                      <v-text-field
                        v-model="editedAddress.email"
                        label="Email Id"
                        outlined
                        class="pb-0 required"
                        :rules="[
                          (v) =>
                            (v && !!v.trim()) || 'Email address is required',
                          (v) =>
                            /.+@.+\..+/.test(v) ||
                            'E-mail address must be valid',
                        ]"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" class="pb-0">
                      <v-switch
                        v-model="editedAddress.address_status"
                        label="Status"
                        outlined
                        class="pb-0"
                      ></v-switch>
                    </v-col>
                  </v-row>
                </v-form>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-btn
                color="primary"
                @click="save"
                :loading="saveLoader"
                class="ml-6"
              >
                {{ editedIndex === -1 ? "Add" : "Update" }}
              </v-btn>
              <v-btn color="primary" @click="close" class="error">
                Cancel
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template v-slot:item.country_code="{ item }">
        {{ item.country_code.toUpperCase() }}
      </template>
      <template v-slot:item.address_area="{ item }">
        {{ item.street_address }}
      </template>
      <template v-slot:item.address_status="{ item }">
        {{ item.address_status === true ? "Active" : "Inactive" }}
      </template>
      <template
        v-slot:[`item.actions`]="{ item }"
        v-if="checkPermission('app_client:client_address_update')"
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon small-chips class="mr-2" v-on="on" @click="editItem(item)">
              mdi-pencil
            </v-icon>
          </template>
          <span>Edit</span>
        </v-tooltip>
      </template>
    </v-data-table>
    <ConfirmDialog
      :dialog="dialogDelete"
      text="Are you sure want to delete this address?"
      :loader="statusLoader"
      @confirm="confirmDelete"
      @close="closeConfirm"
    />
  </v-col>
</template>
<script>
import { mapActions } from "vuex";
import ConfirmDialog from "@/components/front/common/ConfirmDialog";
// import { countries } from "@/config/data";
export default {
  components: {
    ConfirmDialog,
  },
  async created() {
    this.selectedClient = this.$route.params.id;
    await this.getCountryList();
    this.fetchCLientList();
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Add New" : "Edit";
    },
    // allCountries() {
    //   return Object.keys(countries).map((i) => {
    //     return {
    //       text: countries[i],
    //       value: i,
    //     };
    //   });
    // },
  },
  data: () => ({
    dialogDelete: false,
    search: "",
    searchType: "country_id__code",
    searchOptions: [
      {
        text: "Country",
        value: "country_id__code",
      },
      {
        text: "Nick Name",
        value: "address_nick_name",
      },
      {
        text: "Company",
        value: "company_name",
      },
    ],
    addressTypes: [
      {
        text: "Shipping",
        value: 2,
      },
      {
        text: "Billing",
        value: 1,
      },
      {
        text: "Lastmile",
        value: 3,
      },
    ],
    headers: [
      {
        text: "Type",
        value: "address_type_name",
        class: "body-1 font-weight-bold",
      },
      {
        text: "Country",
        value: "country_code",
        class: "body-1 font-weight-bold",
      },
      {
        text: "City",
        value: "city_name",
        class: "body-1 font-weight-bold",
      },
      {
        text: "Address",
        value: "address_area",
        class: "body-1 font-weight-bold",
      },
      {
        text: "Status",
        value: "address_status",
        class: "body-1 font-weight-bold",
      },

      {
        text: "Mobile Number",
        value: "phone_number",
        class: "body-1 font-weight-bold",
      },
      {
        text: "Actions",
        value: "actions",
        sortable: false,
        class: "body-1 font-weight-bold",
        width: "150px",
      },
    ],
    addresses: [],
    options: {},
    total: 0,
    addressesLoader: false,
    statusLoader: false,
    editedIndex: -1,
    editedAddress: {
      address_type: "",
      street_address: "",
      address_area: "",
      area_name: "",
      city_name: "",
      state: "",
      country_code: "",
      zip_code: "",
      phone_number: "",
      email: "",
      address_status: false,
    },
    saveLoader: false,
    dialog: false,
    address_id: "",
    clients: [],
    citiesList: [],
    cityLoader: false,
  }),

  watch: {
    options: {
      handler() {
        this.fetchClientAddresses();
      },
      deep: true,
    },
    search() {
      this.fetchClientAddresses();
    },
    searchType() {
      if (this.search) this.fetchClientAddresses();
    },
  },

  methods: {
    ...mapActions([
      "getClientAddresses",
      "deleteClientAddress",
      "snackBar",
      "createClientAddress",
      "updateClientAddress",
      "fetchClient",
      "fetchCityList",
      "getCountries",
    ]),
    async getCountryList() {
      await this.getCountries().then((res) => {
        this.allCountries = res.data;
      });
    },
    cityList(value) {
      this.cityLoader = true;
      this.fetchCityList(value).then((res) => {
        this.citiesList = res.data;
        this.cityLoader = false;
      });
    },
    fetchCLientList() {
      this.fetchClient().then((res) => {
        this.clients = res.data;
      });
    },
    clientTypeList() {
      this.$route.params.id = this.selectedClient;
      this.id = this.selectedClient;
      this.$router.replace({
        params: {
          id: this.$route.params.id,
        },
      });
      this.fetchClientAddresses();
    },
    fetchClientAddresses() {
      if (this.$route.params.id !== undefined) {
        this.addresses = [];
        this.addressesLoader = true;
        this.getClientAddresses(this.$route.params.id)
          .then((res) => {
            this.addressesLoader = false;
            this.addresses = res.data.records;
            this.total = res.data.total;
          })
          .catch(() => {
            this.addressesLoader = false;
          });
      }
    },
    closeConfirm() {
      this.dialogDelete = false;
    },
    confirmDelete() {
      this.deleteLoader = true;
      this.deleteClientAddress(this.editedAddress.id)
        .then((res) => {
          this.deleteLoader = false;
          this.snackBar({
            color: "success",
            message: res.data.message,
          });
          this.fetchClientAddresses();
          this.closeConfirm();
        })
        .catch(() => {
          this.deleteLoader = false;
        });
    },
    removeAddress(item) {
      this.editedIndex = this.addresses.indexOf(item);
      this.editedAddress = Object.assign({}, item);
      this.dialogDelete = true;
    },
    goToDetails(id) {
      this.$router.push({
        name: "ClientAddressDetails",
        params: {
          id,
        },
      });
    },
    save() {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.saveLoader = true;
      if (this.editedIndex > -1) {
        this.updateClientAddress({
          id: this.$route.params.id,
          address_id: this.address_id,
          data: this.editedAddress,
        })
          .then((res) => {
            this.saveLoader = false;
            this.snackBar({
              color: "success",
              message: res.data.message,
            });
            this.dialog = false;
            this.editedIndex = -1;
            this.editedAddress = {};
            this.fetchClientAddresses();
          })
          .catch(() => {
            this.dialog = false;
            this.editedIndex = -1;
            this.editedAddress = {};
            this.saveLoader = false;
          });
      } else {
        this.createClientAddress({
          id: this.$route.params.id,
          params: this.editedAddress,
        })
          .then((res) => {
            this.saveLoader = false;
            this.snackBar({
              color: "success",
              message: res.data.message,
            });
            this.dialog = false;
            this.fetchClientAddresses();
          })
          .catch(() => {
            this.saveLoader = false;
            this.dialog = false;
          });
      }
    },
    editItem(item) {
      this.editedIndex = this.addresses.indexOf(item);
      this.editedAddress = Object.assign({}, item);
      this.dialog = true;
      this.address_id = item.id;
      this.cityList(item.country_code);
    },
    close() {
      this.dialog = false;
      this.editedAddress = {};
      this.editedIndex = -1;
      this.$refs.form?.reset();
    },
    addAddress() {
      if (this.selectedClient == undefined) {
        this.snackBar({
          color: "error",
          message: "Client is required",
        });
      } else {
        this.dialog = true;
      }
    },
  },
};
</script>
